<template>
<div>
  <v-layout v-if="loading" row justify-center>
    <v-flex class="text-xs-center py-5 my-5" xs12>
      <v-progress-circular color="accent" indeterminate></v-progress-circular>
    </v-flex>
  </v-layout>
  <v-layout v-else class="pt-3" row wrap justify-center>
    <v-flex xs12 md10>
      <v-card @copy.prevent="" class="px-2 mx-2 py-2 elevation-0">
        <div class="display-2 text-xs-center"><b>{{taskData.name}}</b></div>
        <v-divider class="my-3"></v-divider>
        <video v-if="videoUrl" id="lecture-player" class="video-js lecture-video" preload="auto" data-setup='{}' controls>
          <source type="video/mp4" :src="videoUrl">
        </video>
        <div v-else class="display-3 text-xs-center grey--text text--lighten-3">No Video Uploaded</div>
      </v-card>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import firebase from '@firebase/app'
import '@firebase/storage'
import videojs from 'video.js'
export default {
  data: () => ({
    loading: false,
    contentProgress: {},
    taskData: null,
    video: null,
    videoUrl: null
  }),
  beforeMount () {
    this.load()
  },
  updated () {
    if (this.video === null && this.videoUrl) {
      try {
        this.video = videojs('lecture-player')
      } catch (err) {}
    }
  },
  beforeDestroy () {
    if (this.video) this.video.dispose()
  },
  methods: {
    load () {
      this.loading = true
      this.currentProgress = this.$store.getters.currentProgress
      this.taskData = this.$store.getters.taskByKey(this.currentProgress.task)
      let videoRef = null
      if (this.taskData.type === 'Linking') this.taskData = this.$store.getters.taskByKey(this.taskData.linkedTaskKey)
      if (this.taskData.fileName) {
        if (this.taskData.fileName !== '') {
          videoRef = firebase.storage().ref().child('lectures').child(this.taskData.key).child(this.taskData.fileName)
          if (videoRef) {
            videoRef.getDownloadURL().then(url => {
              this.videoUrl = url
              this.loading = false
            })
          } else this.loading = false
        }
      }
      this.saveProgress()
    },
    saveProgress () {
      let taskProgress = this.$store.getters.taskProgressByTaskByProgress(this.currentProgress.task, this.currentProgress.progress)
      if (!taskProgress) {
        const newTaskProgress = {
          taskKey: this.currentProgress.task,
          progressKey: this.currentProgress.progress,
          studentId: this.$store.getters.user.uid,
          startTime: this.$store.getters.now,
          complete: true
        }
        this.$store.dispatch('createTaskProgress', newTaskProgress).catch(err => {
          const appMsg = {
            type: 'error',
            msg: err.message
          }
          this.$store.dispatch('showAppMsg', appMsg)
        })
      }
    }
  }
}
</script>

<style>
.lecture-video {
  max-width: 100%;
  height: 375px;
}
.invisible {
  width: 0.1px  !important;
  height: 0.1px  !important;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/myCourses/LectureTask.vue